<template>
  <div class="selectStorageStyle">
    <v-select
      v-model="inputedValue"
      item-text="label"
      item-value="value"
      :items="items"
      dense
      outlined
      return-object
      class="original-selectbox"
      hide-details
      :placeholder="$t('common.input_unselected_2')"
      :height="height"
      :no-data-text="$t('common.common_not-storage-register')"
    >
    </v-select>
  </div>
</template>

<script>
import { storageUtil } from '@/util'
export default {
  components: {
    //
  },
  props: {
    value: {
      type: Object,
      require: false,
      default: () => ({
        start: '',
        end: ''
      })
    },
    height: { default: '32px' },
    hasDefault: { default: true },
    isHideUnusedStorage: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    items: []
  }),
  async created() {
    const itemsTmp = await storageUtil.getStorageIdNameList(
      this.isHideUnusedStorage
    )
    this.items = itemsTmp ? itemsTmp.data : []
    if (itemsTmp && itemsTmp.data && this.hasDefault) {
      this.inputedValue = itemsTmp.data[0]
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.selectStorageStyle {
  width: 100%;
}
</style>
